import { usePersonalInformation } from '@scfhp-web/shared-module';

interface CustomField {
  name: string;
  value: string;
}

interface CoverageStatusValue {
  coverageStatus: boolean;
  expiryDate: string;
}

/**
 * Hook to determine if the user has active coverage.
 * Reads the `coverageStatus` custom field from the user profile.
 *
 * When the user is terminated, the custom field value will have:
 * `{ "coverageStatus": false, "expiryDate": "..." }`
 *
 * @returns `true` if the user has active coverage, `false` if terminated.
 * Defaults to `true` if the field is missing or cannot be parsed.
 */
export const useCoverageStatus = (): boolean => {
  const { data: personalInformation } = usePersonalInformation();

  const coverageField = personalInformation?.customFields?.find(
    (field: CustomField) => field.name === 'coverageStatus',
  );

  if (!coverageField?.value) {
    return true;
  }

  try {
    const parsed: CoverageStatusValue = JSON.parse(coverageField.value);
    return parsed.coverageStatus !== false;
  } catch {
    return true;
  }
};
